import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { SortableField } from '../../constants/orders'
import { SortState } from '../../reducers/condition'
import { ResultTableProps } from '../result-table'
import { Header, Props as HeaderProps } from './Header'
import { COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS } from '../../reducers/column'

type Props = HeaderProps &
  ResultTableProps & {
    name: SortableField
  }

export const SortableHeader: React.FC<Props> = (props) => {
  const name = props.name
  const state = props.sorting
  const onToggle = props.onToggle
  const iconClass = ({ sort, order }: SortState, name: SortableField) => {
    if (sort === name) {
      return order === 'ASC'
        ? 'icomoon icon-arrow8-up selected'
        : 'icomoon icon-arrow8-down selected'
    } else {
      return 'icomoon icon-sort-fill'
    }
  }

  // todo:初回面談日のソートが実装できるまではソート用カラム特有の要素を削除しておく
  const icon =
    props.name === 'firstInterviewDate' ? (
      <></>
    ) : (
      <span
        css={css`
          font-size: 10px;
          padding: 5px 7px;
          color: #999;
          cursor: pointer;
          font-size: 1rem;
          position: absolute;
          margin: 0;
          top: 10px;
          right: 6px;
          vertical-align: middle;
          border-radius: 50%;
          padding-left: 6px;
          padding-right: 6px;
          transition: 0.15s;
          &:hover {
            background-color: #d9d9d9;
            color: ${colors.gray90};
          }
          & > i.selected {
            color: ${colors.cyan50};
          }
        `}
      >
        <i className={iconClass(state, name)} onClick={() => onToggle(name)} />
      </span>
    )
  return (
    <Header
      right={props.right}
      extra={icon}
      style={{ width: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].width }}
    >
      {props.children}
    </Header>
  )
}
